var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderBackup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 129,
    viewBox: "0 0 141 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 23.1001C8.09961 16.4727 13.4722 11.1001 20.0996 11.1001H40.0986C53.5723 11.1001 55.2565 23.1001 72.0986 23.1001H120.899C127.527 23.1001 132.899 28.4727 132.899 35.1001V105.5C132.899 112.127 127.527 117.5 120.899 117.5H20.0996C13.4722 117.5 8.09961 112.127 8.09961 105.5V23.1001Z",
    fill: "#52AFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 23.1001C8.09961 16.4727 13.4722 11.1001 20.0996 11.1001H40.0986C53.5723 11.1001 55.2565 23.1001 72.0986 23.1001H120.899C127.527 23.1001 132.899 28.4727 132.899 35.1001V105.5C132.899 112.127 127.527 117.5 120.899 117.5H20.0996C13.4722 117.5 8.09961 112.127 8.09961 105.5V23.1001Z",
    fill: "url(#paint0_linear_1795_13095)",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1795_13095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5002 105.5C5.74966 99.4957 2.18264 58.2853 1.74438 53.2118C1.71477 52.869 1.69656 52.527 1.71112 52.1833C1.9817 45.7956 7.24587 40.7 13.7002 40.7L127.3 40.7C133.754 40.7 139.019 45.7956 139.289 52.1833C139.304 52.527 139.286 52.869 139.256 53.2118C138.818 58.2852 135.251 99.4957 134.5 105.5C133.7 111.9 129.128 117.5 122.5 117.5H18.5002C11.8728 117.5 7.3002 111.9 6.5002 105.5Z",
    fill: "#73D0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5002 105.5C5.74966 99.4957 2.18264 58.2853 1.74438 53.2118C1.71477 52.869 1.69656 52.527 1.71112 52.1833C1.9817 45.7956 7.24587 40.7 13.7002 40.7L127.3 40.7C133.754 40.7 139.019 45.7956 139.289 52.1833C139.304 52.527 139.286 52.869 139.256 53.2118C138.818 58.2852 135.251 99.4957 134.5 105.5C133.7 111.9 129.128 117.5 122.5 117.5H18.5002C11.8728 117.5 7.3002 111.9 6.5002 105.5Z",
    fill: "url(#paint1_radial_1795_13095)",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 69V79.5",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6 84.75L70.5 79.5",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2061 73.3093H49.4561V64.5593",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8936 93.1063C59.5851 95.8 63.0151 97.6349 66.7496 98.379C70.4842 99.123 74.3555 98.7427 77.8739 97.2862C81.3923 95.8297 84.3997 93.3624 86.5156 90.1964C88.6315 87.0304 89.7609 83.308 89.7609 79.5C89.7609 75.6921 88.6315 71.9696 86.5156 68.8037C84.3997 65.6377 81.3923 63.1704 77.8739 61.7138C74.3555 60.2573 70.4842 59.877 66.7496 60.621C63.0151 61.3651 59.5851 63.2 56.8936 65.8938L49.4561 73.3094",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 69V79.5",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6 84.75L70.5 79.5",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2061 73.3093H49.4561V64.5593",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8936 93.1063C59.5851 95.8 63.0151 97.6349 66.7496 98.379C70.4842 99.123 74.3555 98.7427 77.8739 97.2862C81.3923 95.8297 84.3997 93.3624 86.5156 90.1964C88.6315 87.0304 89.7609 83.308 89.7609 79.5C89.7609 75.6921 88.6315 71.9696 86.5156 68.8037C84.3997 65.6377 81.3923 63.1704 77.8739 61.7138C74.3555 60.2573 70.4842 59.877 66.7496 60.621C63.0151 61.3651 59.5851 63.2 56.8936 65.8938L49.4561 73.3094",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1795_13095",
    x: 1.70605,
    y: 32.7,
    width: 137.588,
    height: 84.7998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.686275 0 0 0 0 0.878431 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1795_13095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1795_13095",
    x1: 70.4986,
    y1: 29.5001,
    x2: 70.4986,
    y2: 53.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00529E",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1795_13095",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5002 53.4999) rotate(90) scale(48 76.8002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBackup);
export default __webpack_public_path__ + "static/media/folder-backup.dd7935348189bab7c4e34178e7de5981.svg";
export { ForwardRef as ReactComponent };